import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const AppSlice = createSlice({
    name: 'leave-management-info-state',
    initialState: {
        isClickedViewLeave: '',
        isReportingManager: false,
        userDetails: {
            employmentType : '',
            gender: ''
        }
    } as { isReportingManager: boolean,  userDetails: {employmentType: String, gender: String}, isClickedViewLeave: string},
    reducers: {
        setIsReportingManager: (state, action: PayloadAction<boolean | undefined>) => {
            state.isReportingManager = action.payload;
        },
        setUserDetails: (state, action: PayloadAction<{employmentType : string, gender: string}>) => {
            state.userDetails = action.payload;
        },
        setIsClickedViewLeave: (state, action: PayloadAction<string | undefined>) => {
            state.isClickedViewLeave = action.payload;
        },
    }
});

const { reducer, actions } = AppSlice;

export const LeaveManagementActions = actions;
export const LeaveManagementReducer = reducer;